module.exports = __webpack_public_path__ + "static/media/back-icon.8ae9cce5.svg";